import SearchBar from "@/components/form/hook-form/search-bar";
import { FilledButton } from "@/components/ui/buttons/FilledButton";
import { SettingModalHeader } from "@/features/user-profile/components/setting-modal-header";
import { IonContent, IonModal } from "@ionic/react";
import { memo, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";

interface SearchDislikeFoodModalProps {
  pageRef: React.RefObject<HTMLElement>;
  isOpen: boolean;
  onSave: (foods: string[]) => void;
  onDismiss: () => void;
}

interface SearchFormValues {
  search: string;
}

export const SearchDislikeFoodModal = memo(function SearchDislikeFoodModal({
  isOpen,
  onSave,
  onDismiss,
}: SearchDislikeFoodModalProps) {
  const modalRef = useRef<HTMLIonModalElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const { control, watch, reset } = useForm<SearchFormValues>({
    defaultValues: { search: "" },
  });

  const trimmedSearch = (watch("search") ?? "").trim();

  useEffect(() => {
    if (!isOpen) return;
    const timer = window.setTimeout(() => inputRef.current?.focus(), 150);
    return () => window.clearTimeout(timer);
  }, [isOpen]);

  const handleDismiss = () => {
    reset();
    onDismiss();
  };

  const handleConfirm = () => {
    if (!trimmedSearch) return;
    onSave([trimmedSearch]);
    handleDismiss();
  };

  return (
    <IonModal ref={modalRef} isOpen={isOpen} onDidDismiss={handleDismiss} handle={false}>
      <SettingModalHeader title="Add Disliked Food" isModal onBack={handleDismiss} />
      <IonContent scrollY={false}>
        <div className="flex h-full flex-col gap-4 px-4 pt-4">
          <SearchBar
            control={control}
            name="search"
            placeholder="Search"
            onSubmit={handleConfirm}
            inputRef={inputRef}
            className="bg-[#f5f5f5] border-[#ebe0fb]"
          />
          <div className="flex flex-1 items-center justify-center">
            {trimmedSearch ? (
              <FilledButton
                color="brand"
                text={`Add "${trimmedSearch}"`}
                textCase="normal"
                onClick={handleConfirm}
                className="w-auto px-8"
              />
            ) : (
              <p className="text-sm font-medium text-gray-400">Start typing to search</p>
            )}
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
});
